import api from './api';

// جلب جميع الشركات (للوحة التحكم)
export const getCompanies = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/companies/admin/all?${queryParams}`);
  return response.data;
};

// جلب الشركات النشطة (للتخصيص)
export const getAvailableCompanies = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/companies?${queryParams}`);
  return response.data;
};

export const getCompanyById = async (id) => {
  const response = await api.get(`/companies/${id}`);
  return response.data;
};

export const createCompany = async (data) => {
  const response = await api.post('/companies', data);
  return response.data;
};

export const updateCompany = async (id, data) => {
  const response = await api.put(`/companies/${id}`, data);
  return response.data;
};

export const deleteCompany = async (id) => {
  const response = await api.delete(`/companies/${id}`);
  return response.data;
};

export const updateCompanyStatus = async (id, status) => {
  const response = await api.patch(`/companies/${id}/status`, { status });
  return response.data;
};

export const getTourCompanyStats = async (id) => {
  const response = await api.get(`/performance/tour-companies/${id}/stats`);
  return response.data;
};

export const recordTourCompanyPayment = async (id, paymentData) => {
  const response = await api.post(`/performance/tour-companies/${id}/payments`, paymentData);
  return response.data;
};
